import IconLoading from "../icons/IconLoading";

export default function LoaderPage() {
  return (
    <div className="loader-page padding-m flex flex-align-center flex-justify-center flex-direction-column flex-gap-m">
      <h1>Edge Solutions Platform</h1>
      <h2>Loading your data...</h2>
      <div>
        <IconLoading />
      </div>
    </div>
  );
}
